module.exports = __webpack_public_path__ + "static/media/PeterWolf_2019_CWS_Task_1129.f360a7e2.pdf";